export enum ChargeTypes {
    PHYSICIAN_CHARGES = "PHYSICIAN_CHARGES",
    ANESTHESIA_CHARGES = "ANESTHESIA_CHARGES",
    HOSPITAL_CHARGES = "HOSPITAL_CHARGES"
}
